<template>
  <v-card>
    <v-toolbar card color="white">
      <!-- <match-filters v-model="localFilters" @search="search" /> -->
      <v-text-field
        v-model="localFilters.match"
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
      />
      <v-btn
        v-if="can('create', 'tournament')"
        small
        color="primary"
        @click="setNew"
      >
        {{ $t('action.buttons.new') }}
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="
          formatedList.filter((tournament) =>
            can('edit', 'tournament', tournament)
          )
        "
        :rows-per-page-items="[10, 25, 50]"
        :loading="loading"
        disable-initial-sort
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon
              color="primary"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              visibility
            </v-icon>
            <v-icon
              v-if="can('delete', 'tournament')"
              color="error"
              @click="ifDelete(props.item._id)"
            >
              delete
            </v-icon>
          </td>

          <td style="min-width: 250px">
            {{ props.item.name }}
          </td>
          <td class="text-xs-center" style="min-width: 130px">
            {{ props.item.startAt }}
          </td>
          <td class="text-xs-center" style="min-width: 130px">
            {{ props.item.endAt }}
          </td>
          <td class="text-xs-center" style="min-width: 130px">
            {{ props.item.participants }} / {{ props.item.numberParticipants }}
          </td>

          <td class="text-xs-center">
            <button-state :state="props.item.openInscription" />
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td class="text-xs-center" style="min-width: 180px">
            {{ props.item.createdAt }}
          </td>
          <td style="min-width: 150px">
            {{ props.item.createdBy }}
          </td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'
// import MatchFilters from './MatchFilters'

export default {
  name: 'TournamentList',
  components: {
    DialogDelete,
    DialogUpdatedRecord,
    // , MatchFilters
  },

  data() {
    return {
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    'filters.match': {
      handler: function (/* val, oldVal */) {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('tournaments')
      },
    },
    'localPagination.page': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('tournaments')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('tournaments')
      },
    },
    'localPagination.sortBy': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('tournaments')
      },
    },
    'localPagination.descending': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('tournaments')
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.tournaments.loading,
      selected: (state) => state.tournaments.selected,
      pagination: (state) => state.tournaments.pagination,
      filters: (state) => state.tournaments.filters,
    }),
    ...mapGetters({
      formatedList: 'tournaments/formatedList',
    }),
    headers() {
      let headers = [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          sortable: false,
        },

        {
          text: this.$t('fields.tournaments.startAt'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.tournaments.endAt'),
          align: 'center',
          sortable: false,
        },

        {
          text: this.$t('titles.tournaments.participantsQuantity'),
          sortable: false,
        },
        {
          text: this.$t('fields.tournaments.openInscription'),
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
          sortable: false,
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.createdBy'),
          sortable: false,
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
      return headers
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('tournaments/setFilters', value)
      },
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('tournaments/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'tournaments/fetchOne',
      fetchSimplified: 'tournaments/fetchSimplified',
      setDelete: 'tournaments/delete',
      reset: 'tournaments/reset',
      fetchList: 'tournaments/fetchList',
    }),
    init() {
      this.debounceFetch('tournaments')
    },
    search() {
      this.localPagination.page = 1
      this.init()
    },
    setNew() {
      this.reset()
      this.$emit('form')
    },
    setOne(id) {
      this.fetchOne(id).then(() => {
        this.nextTick(() => this.$emit('view'))
      })
    },
    openUpdated(id) {
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
  },
}
</script>
